import { getPortFolioByUserId } from 'APIs/portfolio.api'
import { blockOrActiveUser, getInfoUserAndPortfolio, getUserList } from 'APIs/userList'
import { hideOverlay, showModalMessage, showOverlay } from 'Modules/store/actions'
import { call, put, takeLatest } from 'redux-saga/effects'
import { REQUEST, SUCCESS } from 'Stores'
import {
  BLOCK_OR_ACTIVE_USER,
  GET_ALL_PORTFOLIO_BY_USER_ID,
  GET_INFO_USER_AND_PORTFOLIO,
  GET_USER_LIST
} from './constants'

export function* getUserListSaga({ payload }) {
  try {
    yield put(showOverlay())
    const data = yield call(getUserList, payload)
    yield put({
      type: SUCCESS(GET_USER_LIST),
      payload: {
        users: data.result.rows,
        total: data.result.count
      }
    })
    yield put(hideOverlay())
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put(hideOverlay())
  }
}

export function* blockOrActiveUserSaga({ payload }) {
  try {
    const { dataBlock, dataGet } = payload
    yield put(showOverlay())
    yield call(blockOrActiveUser, dataBlock)
    yield put({
      type: SUCCESS(BLOCK_OR_ACTIVE_USER)
    })
    const data = yield call(getUserList, dataGet)
    yield put({
      type: SUCCESS(GET_USER_LIST),
      payload: {
        users: data.result.rows,
        total: data.result.count
      }
    })
    yield put(hideOverlay())
    yield put(showModalMessage({ message: dataBlock.active ? 'Active success' : 'Block success', type: 'success' }))
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put(hideOverlay())
  }
}

export function* getAllPortfolioByUserIdSaga({ payload }) {
  try {
    const { userId } = payload
    const data = yield call(getPortFolioByUserId, userId)
    yield put({
      type: SUCCESS(GET_ALL_PORTFOLIO_BY_USER_ID),
      payload: {
        portfolios: data.result
      }
    })
  } catch (error) {
    yield put(showModalMessage({ message: error }))
  }
}

export function* getInfoUserAndPortfolioSaga({ payload }) {
  try {
    const data = yield call(getInfoUserAndPortfolio, payload)
    yield put({
      type: SUCCESS(GET_INFO_USER_AND_PORTFOLIO),
      payload: {
        info: data.result
      }
    })
  } catch (error) {
    yield put(showModalMessage({ message: error }))
  }
}

export default function* userListSaga() {
  yield takeLatest(REQUEST(GET_USER_LIST), getUserListSaga)
  yield takeLatest(REQUEST(BLOCK_OR_ACTIVE_USER), blockOrActiveUserSaga)
  yield takeLatest(REQUEST(GET_ALL_PORTFOLIO_BY_USER_ID), getAllPortfolioByUserIdSaga)
  yield takeLatest(REQUEST(GET_INFO_USER_AND_PORTFOLIO), getInfoUserAndPortfolioSaga)
}
